export function getAllStores(state) {
  return state.allStores;
}

export function getMasterStore(state) {
    return state.masterStore;
  }
export function getSubStores(state) {
    return state.subStores;
  }
export function getSelectedStore(state) {
    return state.selectedStore;
  }